import { Outlet } from "react-router";
import SideNav from "../../../Components/Admin/shared/SideNav";
import TopNav from "../../../Components/Admin/shared/TopNav";

export default function DashboardProvider() {
  return (
    <div className='flex'>
      <SideNav />
      <div className='w-full overflow-hidden'>
        <div className='flex-1 overflow-x-auto'>
          <TopNav />
          <Outlet />
        </div>
      </div>
    </div>
  );
}
